module.exports = __webpack_public_path__ + "static/img/settings.b86c823e.svg";